export default {"src":"/_next/static/media/angular_logo_240d8fd911.0b279482.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};